// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html:has(.v2-game-inactive),
html:has(.v2-game-inactive) body,
html:has(.v2-game-inactive) #root,
body:has(.v2-game-inactive) {
  background: #06030d !important;
  background-image: none !important;
}

.v2-game-inactive,
.v2-game-inactive * {
  box-sizing: border-box;
  font-family: "Plus Jakarta Sans", sans-serif !important;
}

.v2-game-inactive {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  color: #ffffff;
  background-color: transparent;
  background-image: radial-gradient(ellipse 48% 52vh at 92% 0%, rgba(88, 28, 135, 0.34) 0%, transparent 62%), radial-gradient(ellipse 44% 48vh at 6% 58%, rgba(46, 16, 82, 0.42) 0%, transparent 62%), radial-gradient(ellipse 52% 48vh at 50% 100%, rgba(72, 24, 120, 0.28) 0%, transparent 62%);
}

.v2-game-inactive-glow {
  position: absolute;
  left: 50%;
  top: 46%;
  width: 28rem;
  height: 28rem;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(circle, rgba(72, 28, 120, 0.35) 0%, transparent 68%);
  filter: blur(8px);
  pointer-events: none;
}

.v2-game-inactive-brand {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 32px 64px 0;
}

.v2-game-inactive-logo {
  display: block;
  height: 28px;
  width: auto;
}

.v2-game-inactive-stage {
  position: relative;
  z-index: 1;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.25rem 3.5rem;
}

.v2-game-inactive-card {
  width: min(32rem, 100%);
  padding: 2.75rem 2.25rem 2.25rem;
  text-align: center;
  border: 1px solid rgba(168, 85, 247, 0.22);
  border-radius: 1.5rem;
  background: rgba(22, 16, 42, 0.94);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.03) inset, 0 24px 60px rgba(40, 12, 72, 0.45);
  backdrop-filter: blur(16px);
}

.v2-game-inactive-mark {
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 1.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f3e8ff;
  border-radius: 50%;
  background: #2a1848;
  border: 1px solid rgba(168, 85, 247, 0.35);
  box-shadow: 0 10px 24px rgba(18, 8, 36, 0.55);
}

.v2-game-inactive-mark img {
  width: 1.7rem;
  height: 1.7rem;
  position: relative;
  z-index: 1;
  filter: brightness(0) invert(1);
}

.v2-game-inactive-mark-ring {
  position: absolute;
  inset: -0.55rem;
  border-radius: 50%;
  border: 1px solid rgba(120, 70, 170, 0.45);
}

.v2-game-inactive-kicker {
  margin: 0 0 0.55rem !important;
  color: #c4a8e8 !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.14em !important;
  text-transform: uppercase;
}

.v2-game-inactive-card h1 {
  margin: 0 0 0.7rem !important;
  color: #ffffff !important;
  font-size: clamp(1.7rem, 3vw, 2.15rem) !important;
  font-weight: 800 !important;
  line-height: 1.15 !important;
  letter-spacing: -0.035em !important;
}

.v2-game-inactive-copy {
  margin: 0 auto !important;
  max-width: 24rem;
  color: #b7adc8 !important;
  font-size: 0.98rem !important;
  font-weight: 500 !important;
  line-height: 1.65 !important;
}

.v2-game-inactive-copy strong {
  color: #ffffff;
  font-weight: 700;
}

.v2-game-inactive-actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.7rem;
  margin-top: 1.75rem;
}

.v2-game-inactive-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 8.5rem;
  height: 44px;
  padding: 0 1.25rem;
  border-radius: 100px;
  font-size: 14px !important;
  font-weight: 700 !important;
  line-height: 1;
  cursor: pointer;
  transition: transform 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.v2-game-inactive-btn svg {
  width: 16px;
  height: 16px;
  display: block;
}

.v2-game-inactive-btn--ghost {
  border: 1px solid rgba(140, 90, 190, 0.55) !important;
  background: transparent !important;
  color: #ffffff !important;
}

.v2-game-inactive-btn--ghost:hover {
  background: rgba(42, 24, 72, 0.7) !important;
}

.v2-game-inactive-btn--primary {
  border: 0 !important;
  color: #ffffff !important;
  background: #3b2268 !important;
  box-shadow: 0 10px 24px rgba(18, 8, 36, 0.4);
}

.v2-game-inactive-btn--primary:hover {
  background: #4a2a7a !important;
  transform: translateY(-1px);
}

@media screen and (max-width: 767.98px) {
  .v2-game-inactive-brand {
    padding: 20px 16px 0;
  }
  .v2-game-inactive-card {
    padding: 2.1rem 1.25rem 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GameInactivePage/GameInactivePage.scss"],"names":[],"mappings":"AAEA;;;;EAIE,8BAAA;EACA,iCAAA;AAAF;;AAGA;;EAEE,sBAAA;EACA,uDAAA;AAAF;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,+RACE;AADJ;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;EACA,gFAAA;EACA,iBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AAHF;;AAMA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAHF;;AAMA;EACE,uBAAA;EACA,gCAAA;EACA,kBAAA;EACA,0CAAA;EACA,qBAAA;EACA,kCAAA;EACA,yFACE;EAEF,2BAAA;AALF;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,6CAAA;AALF;;AAQA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,+BAAA;AALF;;AAQA;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,0CAAA;AALF;;AAQA;EACE,8BAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,iCAAA;EACA,yBAAA;AALF;;AAQA;EACE,6BAAA;EACA,yBAAA;EACA,iDAAA;EACA,2BAAA;EACA,4BAAA;EACA,mCAAA;AALF;;AAQA;EACE,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;AALF;;AAQA;EACE,cAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,8EAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,cAAA;AALF;;AAQA;EACE,qDAAA;EACA,kCAAA;EACA,yBAAA;AALF;;AAQA;EACE,4CAAA;AALF;;AAQA;EACE,oBAAA;EACA,yBAAA;EACA,8BAAA;EACA,4CAAA;AALF;;AAQA;EACE,8BAAA;EACA,2BAAA;AALF;;AAQA;EACE;IACE,oBAAA;EALF;EAQA;IACE,8BAAA;EANF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap\");\n\nhtml:has(.v2-game-inactive),\nhtml:has(.v2-game-inactive) body,\nhtml:has(.v2-game-inactive) #root,\nbody:has(.v2-game-inactive) {\n  background: #06030d !important;\n  background-image: none !important;\n}\n\n.v2-game-inactive,\n.v2-game-inactive * {\n  box-sizing: border-box;\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n\n.v2-game-inactive {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  color: #ffffff;\n  background-color: transparent;\n  background-image:\n    radial-gradient(ellipse 48% 52vh at 92% 0%, rgba(88, 28, 135, 0.34) 0%, transparent 62%),\n    radial-gradient(ellipse 44% 48vh at 6% 58%, rgba(46, 16, 82, 0.42) 0%, transparent 62%),\n    radial-gradient(ellipse 52% 48vh at 50% 100%, rgba(72, 24, 120, 0.28) 0%, transparent 62%);\n}\n\n.v2-game-inactive-glow {\n  position: absolute;\n  left: 50%;\n  top: 46%;\n  width: 28rem;\n  height: 28rem;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(72, 28, 120, 0.35) 0%, transparent 68%);\n  filter: blur(8px);\n  pointer-events: none;\n}\n\n.v2-game-inactive-brand {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  padding: 32px 64px 0;\n}\n\n.v2-game-inactive-logo {\n  display: block;\n  height: 28px;\n  width: auto;\n}\n\n.v2-game-inactive-stage {\n  position: relative;\n  z-index: 1;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1.25rem 3.5rem;\n}\n\n.v2-game-inactive-card {\n  width: min(32rem, 100%);\n  padding: 2.75rem 2.25rem 2.25rem;\n  text-align: center;\n  border: 1px solid rgba(168, 85, 247, 0.22);\n  border-radius: 1.5rem;\n  background: rgba(22, 16, 42, 0.94);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.03) inset,\n    0 24px 60px rgba(40, 12, 72, 0.45);\n  backdrop-filter: blur(16px);\n}\n\n.v2-game-inactive-mark {\n  position: relative;\n  width: 4.5rem;\n  height: 4.5rem;\n  margin: 0 auto 1.35rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #f3e8ff;\n  border-radius: 50%;\n  background: #2a1848;\n  border: 1px solid rgba(168, 85, 247, 0.35);\n  box-shadow: 0 10px 24px rgba(18, 8, 36, 0.55);\n}\n\n.v2-game-inactive-mark img {\n  width: 1.7rem;\n  height: 1.7rem;\n  position: relative;\n  z-index: 1;\n  filter: brightness(0) invert(1);\n}\n\n.v2-game-inactive-mark-ring {\n  position: absolute;\n  inset: -0.55rem;\n  border-radius: 50%;\n  border: 1px solid rgba(120, 70, 170, 0.45);\n}\n\n.v2-game-inactive-kicker {\n  margin: 0 0 0.55rem !important;\n  color: #c4a8e8 !important;\n  font-size: 0.72rem !important;\n  font-weight: 700 !important;\n  letter-spacing: 0.14em !important;\n  text-transform: uppercase;\n}\n\n.v2-game-inactive-card h1 {\n  margin: 0 0 0.7rem !important;\n  color: #ffffff !important;\n  font-size: clamp(1.7rem, 3vw, 2.15rem) !important;\n  font-weight: 800 !important;\n  line-height: 1.15 !important;\n  letter-spacing: -0.035em !important;\n}\n\n.v2-game-inactive-copy {\n  margin: 0 auto !important;\n  max-width: 24rem;\n  color: #b7adc8 !important;\n  font-size: 0.98rem !important;\n  font-weight: 500 !important;\n  line-height: 1.65 !important;\n}\n\n.v2-game-inactive-copy strong {\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.v2-game-inactive-actions {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.7rem;\n  margin-top: 1.75rem;\n}\n\n.v2-game-inactive-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 8.5rem;\n  height: 44px;\n  padding: 0 1.25rem;\n  border-radius: 100px;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  line-height: 1;\n  cursor: pointer;\n  transition: transform 160ms ease, background 160ms ease, box-shadow 160ms ease;\n}\n\n.v2-game-inactive-btn svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n.v2-game-inactive-btn--ghost {\n  border: 1px solid rgba(140, 90, 190, 0.55) !important;\n  background: transparent !important;\n  color: #ffffff !important;\n}\n\n.v2-game-inactive-btn--ghost:hover {\n  background: rgba(42, 24, 72, 0.7) !important;\n}\n\n.v2-game-inactive-btn--primary {\n  border: 0 !important;\n  color: #ffffff !important;\n  background: #3b2268 !important;\n  box-shadow: 0 10px 24px rgba(18, 8, 36, 0.4);\n}\n\n.v2-game-inactive-btn--primary:hover {\n  background: #4a2a7a !important;\n  transform: translateY(-1px);\n}\n\n@media screen and (max-width: 767.98px) {\n  .v2-game-inactive-brand {\n    padding: 20px 16px 0;\n  }\n\n  .v2-game-inactive-card {\n    padding: 2.1rem 1.25rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
